import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { SubmitButton } from '../../components/Input';

const GeneralCategoryForm = () => {
  const { id } = useParams();  // Get the ID from URL (for Edit)
  const navigate = useNavigate();
  const [categoryName, setCategoryName] = useState('');
  const [operation, setOperation] = useState('Add');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (id) {
      setOperation('Edit');
      // Fetch category details for editing
      fetchCategory(id);
    } else {
      setOperation('Add');
    }
  }, [id]);

  const fetchCategory = async (categoryId) => {
    try {
      const response = await axios.get(`/streetviewcategory/${categoryId}`);
      setCategoryName(response.data.category_name);
      setLoading(false);
    } catch (error) {
      setError('Failed to fetch category data');
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const categoryData = { category_name: categoryName };

    try {
      if (operation === 'Edit') {
        await axios.put(`/streetviewcategory/${id}`, categoryData);
      } else {
        await axios.post('/streetviewcategory', categoryData);
      }
      Swal.fire('Success', 'Category saved successfully', 'success');
      navigate('/Website/StreetViewCategory');  // Redirect to the category list
    } catch (error) {
      Swal.fire('Error', 'Failed to save category', 'error');
    }
  };

  const handleCancel = () => {
    navigate('/Website/StreetViewCategory');  // Redirect back to the category list
  };

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform" encType="multipart/form-data">
            <input type="hidden" name="id" value={id || ''} />
            <div className="panel-heading border-0">
              <span className="panel-title">{operation} Street View Category</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <label>Category Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Category Name"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-actions mt-4">
                <SubmitButton/>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Scroll to top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default GeneralCategoryForm;
